<!--
极致一天
-->
<template>
  <div :class="$style.day">
    <h2 id="js-day-title" :class="$style.title">
      <span class="app-fadeInUp">极致一天</span>
    </h2>
    <div id="js-day-content" :class="$style.content">
      <the-day-swiper :data="data" />
      <div :class="$style.mask" />
    </div>
  </div>
</template>

<script>
import fadeMixins from '@/assets/js/fadeMixins'
import TheDaySwiper from './TheDaySwiper'

export default {
  components: { TheDaySwiper },
  mixins: [fadeMixins],
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      name: 'day',
      animateScenesData: [
        'title',
        {
          title: 'content',
          element: `.${this.$style.mask}`,
          classes: this.$style.mask_active,
        },
      ],
    }
  },
}
</script>

<style lang="less" module>
@content-width: 13rem;

.day {
  padding: @padding-base-title 0;
}

.title {
  margin-bottom: @padding-title-bot;

  span {
    .subtitle-size(3.99rem, 0.9rem);
    .text-hide();
    display: block;
    margin: 0 auto;
    background: url('./images/day-title.png') no-repeat;
    background-size: 100% 100%;
  }
}

.content {
  position: relative;
  width: @content-width;
  margin: 0 auto;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  &::before,
  &::after {
    .size(@content-width * 0.5, @life-day-img-height);
    content: '';
    position: absolute;
    top: 0;
  }

  &::before,
  &::after {
    z-index: 1;
    background-color: #fff;
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }

  &_active {
    &::before,
    &::after {
      width: 0;
      transition: width 1s;
    }
  }
}

@media screen and (max-width: @tablet-width) {
  .content {
    width: @content-width * @life-day-tablet;
  }

  .mask {
    &::before,
    &::after {
      .size(@content-width * @life-day-tablet * 0.5, @life-day-img-height * @life-day-tablet);
    }

    &_active {
      &::before,
      &::after {
        width: 0;
      }
    }
  }
}

@media screen and (max-width: @mini-width) {
  .content {
    width: @content-width * @life-day-mini;
  }

  .mask {
    &::before,
    &::after {
      .size(@content-width * @life-day-mini * 0.5, @life-day-img-height * @life-day-mini);
    }

    &_active {
      &::before,
      &::after {
        width: 0;
      }
    }
  }
}
</style>
